var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3b8ee1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "35px",
    height: "35px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3b8ee1",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M24.634,5.128C23.96,5.399,9.747,11.52,4.852,13.626C4.566,13.749,4,13.936,4,14.546c0,0.49,0.368,0.732,0.792,0.905C5.863,15.888,9.803,17.5,9.803,17.5s1.407,4.306,1.699,5.25c0.292,0.945,0.527,0.967,0.527,0.967c0.065,0.029,0.128,0.04,0.187,0.04c0.188,0,0.333-0.112,0.333-0.112l3.672-3.176l4.308,4.075c0,0,0.428,0.456,0.901,0.456c0.576,0,0.993-0.587,1.066-0.969c0.101-0.534,3.444-17.694,3.444-17.694C26.243,4.954,25.344,4.841,24.634,5.128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.866,10c-0.153,0-0.359,0.149-0.469,0.219c-1.575,1.004-9.469,5.597-11.634,6.855c0.61,0.25,1.04,0.426,1.04,0.426s1.407,4.306,1.699,5.25c0.292,0.945,0.527,0.967,0.527,0.967c0.065,0.029,0.128,0.04,0.187,0.04c0.048,0,0.081-0.017,0.121-0.029l1.439-5.76c0,0,6.556-6.785,6.951-7.18c0.318-0.316,0.384-0.428,0.384-0.537C21.111,10.105,21.036,10,20.866,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.413e68b423754bcb536046185d030eb1.svg";
export { ForwardRef as ReactComponent };